import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';

export interface SelfChallengeTargetResultEntityProps {
  result: boolean;
  localdate: Date;
}

export class SelfChallengeTargetResultEntity extends Entity<SelfChallengeTargetResultEntityProps> {
  protected _id: string;

  static create(
    props: SelfChallengeTargetResultEntityProps,
    entityId?: string
  ): SelfChallengeTargetResultEntity {
    const id = entityId || v4();
    const entity = new SelfChallengeTargetResultEntity({
      id,
      props,
    });
    return entity;
  }

  public validate() {}

  get result(): boolean {
    return this.props.result;
  }
  get localdate(): Date {
    return this.props.localdate;
  }
}
